/* eslint-disable react/prop-types */
const MobileVariationSelector = ({ product, selectedVariation, handleVariationChange, t }) => {

  return (
    <div className={`variation-selector py-1`}>
      <select
        id={`variation-${product.id}`}
        onChange={handleVariationChange}
        value={selectedVariation?.id || ''}
        className="bg-primary-light-studio text-sm font-medium font-secondary rounded-xl transition-all p-1 text-primary-studio w-full"
      >
        <option value="" disabled>{t('select')}</option>
        {product.variations
          .filter(variation => variation.status === 'publish') // Filter by status
          .map(variation => (
            <option key={variation.id} value={variation.id}>
              {variation.attributes.map(attr => decodeURIComponent(attr.option)).join(' / ')}
            </option>
          ))}
      </select>
    </div>
  );
};

export default MobileVariationSelector;
